import $ from 'jquery';
import Vue from "vue";
import Component from "vue-class-component";
import iziToast from "izitoast";
import firebase from "firebase";

@Component
export default class Mixin extends Vue {
  logOut() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.$router.push("/login");
      })
      .catch(error => {
        console.log(error);
      });
  }
  loadFields() {
    console.log("loadFields");
    $("#loading").hide();
  }
  showNotification(
    type: string,
    title?: string,
    message?: string,
    timeout?: number
  ) {
    iziToast.destroy();
    switch (type) {
      case "success":
        iziToast.show({
          title: title !== undefined ? title : "Éxito",
          message:
            message !== undefined ? message : "Información cargada con éxito",
          timeout: timeout !== undefined ? timeout : 3000,
          position: "topRight",
          theme: "light",
          color: "green" // blue, red, green, yellow
        });
        break;

      case "fail":
        iziToast.show({
          title: title !== undefined ? title : "Error",
          message:
            message !== undefined
              ? message
              : "Ocurrió un error al cargar la información",
          timeout: timeout !== undefined ? timeout : 3000,
          position: "topRight",
          theme: "light",
          color: "red" // blue, red, green, yellow
        });
        break;

      case "info":
        iziToast.show({
          title: title !== undefined ? title : "Alerta",
          message: message,
          timeout: timeout !== undefined ? timeout : 3000,
          position: "topRight",
          theme: "light",
          color: "yellow" // blue, red, green, yellow
        });
        break;

      case "loading":
        iziToast.show({
          title: title !== undefined ? title : "Cargando",
          message:
            message !== undefined
              ? message
              : "Cargando información. Un momento por favor...",
          timeout: 0,
          displayMode: 0,
          theme: "dark",
          close: false,
          closeOnEscape: false,
          drag: false,
          animateInside: true,
          overlay: false,
          position: "topRight"
          //icon: 'far fa-clock',
        });
        break;

      default:
        break;
    }
  }

  onlyNumber($event) {
    const keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      // 46 is dot
      $event.preventDefault();
    }
  }

  onlyNumber2($event) {
    const keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if (keyCode < 48 || keyCode > 57) {
      // 46 is dot
      $event.preventDefault();
    }
  }

  formatDateWithHour(date) {
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return (
      day +
      "/" +
      (monthIndex + 1) +
      "/" +
      year +
      " - " +
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
      ":" +
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes())
    );
  }
  formatDateToNameWithoutHour(date: Date) {
    try {
      if (date != null) {
        const monthNames = [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        return (
          day +
          "/" +
          monthNames[monthIndex] +
          "/" +
          year

        );
      } else {
        console.log('formatDateToNameWithoutHour receiving null or empty');
      }
    } catch (e) {
      console.log('formatDateToNameWithoutHour error');
      console.log(e);
    }

  }
}
